'use client';

// imports
import { Quote } from 'lucide-react';
import { useInView } from '@/hooks/useInView';

// constants
const base = 'transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]';
const hidden = 'opacity-0 translate-y-8';
const show = 'opacity-100 translate-y-0';

// component
export default function QuoteSection() {

  // hooks
  const { ref, isVisible } = useInView<HTMLDivElement>({
    threshold: 0.15,
    once: true,
  });

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 xl:px-16">
        <div className="max-w-4xl mx-auto text-center">
          
          {/* quote icon */}
          <div className={`${base} ${isVisible ? show : hidden} flex justify-center mb-8`}>
            <div className="w-16 h-16 bg-blue-50 border border-blue-100 rounded-2xl flex items-center justify-center">
              <Quote size={28} className="text-blue-400" />
            </div>
          </div>

          {/* quote */}
          <blockquote className={`${base} delay-150 ${isVisible ? show : hidden} text-3xl md:text-3xl lg:text-4xl font-bold text-slate-800 leading-tight mb-6`}>
            "Early diagnosis is important to{' '}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
              prevent the worst effects
            </span>{' '}
            of type 2 diabetes."
          </blockquote>

          {/* source */}
          <div className={`${base} delay-300 ${isVisible ? show : hidden} flex items-center justify-center gap-3`}>
            <div className="h-px w-12 bg-slate-200" />
            <div className="text-center">
              <p className="text-slate-500 text-sm font-medium">World Health Organization</p>
              <p className="text-slate-400 text-xs">Global Diabetes Report</p>
            </div>
            <div className="h-px w-12 bg-slate-200" />
          </div>
        </div>
      </div>
    </section>
  );
}